/**
 * AI invoice note indicator for the "Allgemeines" section header.
 * Shows a bot icon when an AI comment exists; full note on hover.
 */

function escapeAiNoteHtml(text) {
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

function formatAiNoteHtml(text) {
  if (!text) return ''
  var isFirstContentLine = true

  return String(text).split('\n').map(function (line) {
    if (!line.trim()) return null

    if (isFirstContentLine) {
      isFirstContentLine = false
      return '<span style="font-weight:700;">' + escapeAiNoteHtml(line) + '</span>'
    }

    var sectionMatch = line.trim().match(/^(Begründung|Hinweise)(\s*:)?\s*(.*)$/)
    if (sectionMatch) {
      var suffix = (sectionMatch[2] || '') + (sectionMatch[3] || '')
      if (!suffix.trim()) {
        return '<span style="font-weight:700;">' + escapeAiNoteHtml(sectionMatch[1]) + '</span>' +
          escapeAiNoteHtml(sectionMatch[2] || '')
      }
      return '<span style="font-weight:700;">' + escapeAiNoteHtml(sectionMatch[1]) + '</span>' +
        escapeAiNoteHtml(suffix)
    }

    return escapeAiNoteHtml(line)
  }).filter(Boolean).join('<br>')
}

/**
 * @param {HTMLElement} headerBadgesContainer - #section-header-badges in Allgemeines header
 * @returns {{ updateAiNoteIndicator: function }}
 */
function aiNoteIndicatorForInvoice(headerBadgesContainer) {
  if (!headerBadgesContainer) {
    return { updateAiNoteIndicator: function () {} }
  }

  var aiNoteIndicator = document.createElement('span')
  aiNoteIndicator.id = 'ai-note-indicator'
  aiNoteIndicator.setAttribute('aria-label', 'KI-Hinweis')
  aiNoteIndicator.style.cssText = `
    display: none;
    position: relative;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    border-radius: 6px;
    line-height: 1;
    cursor: pointer;
    user-select: none;
    color: rgba(0, 0, 0, 0.65);
    background-color: transparent;
  `
  aiNoteIndicator.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M12 8V4H8"/>
      <rect width="16" height="12" x="4" y="8" rx="2"/>
      <path d="M2 14h2"/>
      <path d="M20 14h2"/>
      <path d="M15 13v2"/>
      <path d="M9 13v2"/>
    </svg>
  `

  var aiNoteTooltip = document.createElement('div')
  aiNoteTooltip.style.cssText = `
    display: none;
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: 4px;
    z-index: 1000;
    min-width: 336px;
    max-width: 504px;
    padding: 12px;
    background-color: #fff;
    border: 1px solid #eee;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    font-size: 14px;
    line-height: 1.5;
    color: rgba(0, 0, 0, 0.85);
    word-break: break-word;
    pointer-events: none;
  `

  aiNoteIndicator.appendChild(aiNoteTooltip)
  headerBadgesContainer.appendChild(aiNoteIndicator)

  var aiNoteHasContent = false

  function updateAiNoteIndicator(aiNoteEntries) {
    if (!aiNoteEntries || !aiNoteEntries.length) {
      aiNoteHasContent = false
      aiNoteIndicator.style.display = 'none'
      aiNoteTooltip.innerHTML = ''
      return
    }

    var html = aiNoteEntries
      .map(function (entry) {
        return entry.text ? formatAiNoteHtml(entry.text) : ''
      })
      .filter(Boolean)
      .join('<br><br>')

    if (!html) {
      aiNoteHasContent = false
      aiNoteIndicator.style.display = 'none'
      aiNoteTooltip.innerHTML = ''
      return
    }

    aiNoteHasContent = true
    aiNoteIndicator.style.display = 'inline-flex'
    aiNoteTooltip.innerHTML = html
  }

  aiNoteIndicator.addEventListener('mouseover', function () {
    if (!aiNoteHasContent) return
    aiNoteTooltip.style.display = 'block'
    aiNoteIndicator.style.backgroundColor = 'rgba(0, 0, 0, 0.14)'
  })

  aiNoteIndicator.addEventListener('mouseout', function () {
    aiNoteTooltip.style.display = 'none'
    aiNoteIndicator.style.backgroundColor = 'transparent'
  })

  return { updateAiNoteIndicator }
}
